import Component from '../core/Component'
import { CMS } from '../core/config'
import Scroll, { scrollToElement } from '../services/Scroll'

const STATES = {
    ACTIVE: 'is-active',
}

export default class Wrapper extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            footer: null,
            footerTabHelper: null,
        }
    }

    prepare() {
        if (CMS) {
            return
        }

        this.resize()
        Scroll.on('resize-y', this.handleResize)
        document.addEventListener('toggleblock-change', this.handleToggleBlockChange)
    }

    destroy() {
        Scroll.off('resize-y', this.handleResize)
        document.removeEventListener('toggleblock-change', this.handleToggleBlockChange)
    }

    handleToggleBlockChange = (event) => {
        const { action } = event.detail
        if (action === 'open') {
            this.resize()
            scrollToElement(event.target.parentNode)
        }
    }

    handleResize = () => {
        this.resize()
    }

    resize() {
        const footerHeight = this.ref.footer.offsetHeight
        this.ref.footerTabHelper.style.height = `${footerHeight}px`
        const scroll = Scroll.getScroll()

        if (scroll.window.height > footerHeight) {
            this.element.classList.add(STATES.ACTIVE)
        } else {
            this.element.classList.remove(STATES.ACTIVE)
        }
    }
}
